module.exports = __webpack_public_path__ + "media/images/liv__gradient-fe6637878d5d8afcc2ec835d272a0227.png";